export enum FilterUnionType {
    and = 'and',

    or = 'or'
}
